"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serializeOutcomingOrder = ({ carrierContact, journey: { waypoints, ...restJourney }, ...rest }, update) => ({
    ...rest,
    // TODO: Serialize contact
    carrierContact: carrierContact,
    journey: {
        ...restJourney,
        waypoints: waypoints
            .map((waypoint) => ({
            ...waypoint,
            place: {
                ...waypoint.place,
                image: undefined,
                id: update ? undefined : waypoint.place.id
            }
        }))
    }
});
exports.default = serializeOutcomingOrder;
